import React from "react";
import "./Cta.css";
import { Button } from "./Button";
import { Link } from "react-router-dom";

function Cta({ headline, subtext, buttonText,background }) {
  return (
    <section className="cta" style={{ backgroundImage: `url(${background})` }}>
      <div className="cta-overlay">
        <div className="cta-content">
          <h1>{headline}</h1>
          <p>{subtext}</p>
          <Link to="/contact">
            <Button
              className="btn-mobile"
              buttonStyle="btn--outline"
              buttonSize="btn--large"
            >
              {buttonText}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Cta;
